export const DEFAULT_TRACES_SAMPLE_RATE = 0.026455;
export const STORAGE_KEY_FOR_SAMPLING = 'sentry_sampling';
